export default __webpack_public_path__ + "static/media/hexowatch-logo-rectangle.0bc07c8e.svg";